const CarIcon = ({ active }) => {
  const color = active ? "#0149AD" : "#545454";
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.29107 6.94571C1.36322 6.55213 1.68057 6.14972 2.19271 5.80241C3.11485 5.17703 4.16805 5.1796 5.22223 5.14057C5.57209 5.1276 6.5115 5.12333 7.5 5.12557C8.4885 5.12333 9.42791 5.1276 9.77777 5.14057C10.832 5.1796 11.8851 5.17703 12.8073 5.80241C13.3194 6.14972 13.6368 6.55213 13.7089 6.94571C13.7709 7.28352 13.7613 8.44274 13.6899 9.26079C13.6522 9.69208 13.6138 9.90202 13.5566 9.99023C13.3839 10.2565 12.8854 10.4803 12.152 10.6209C11.4637 10.7528 11.5661 10.75 7.5 10.75C3.43391 10.75 3.53626 10.7528 2.84802 10.6209C2.11462 10.4803 1.61608 10.2565 1.44338 9.99023C1.38615 9.90202 1.34781 9.69208 1.31012 9.26079C1.23867 8.44274 1.22913 7.28352 1.29107 6.94571Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.8125 5.125L3.63328 2.30632C3.70867 2.1188 3.85519 1.9622 4.06168 1.89197C6.08854 1.20268 8.91146 1.20268 10.9383 1.89197C11.1448 1.9622 11.2913 2.1188 11.3667 2.30632L12.1875 5.125"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5625 7L2.5 7.3125"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4375 7L12.5 7.3125"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 10.4375L5.15354 10.0536C5.38188 9.4828 5.49605 9.19737 5.73413 9.03619C5.97221 8.875 6.27962 8.875 6.89444 8.875H8.10556C8.72038 8.875 9.02779 8.875 9.26587 9.03619C9.50395 9.19737 9.61812 9.4828 9.84646 10.0536L10 10.4375"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.37601 11.1014V11.6028C4.37604 12.1492 4.35211 12.2516 4.18714 12.4112C4.13886 12.4578 4.04075 12.525 3.96914 12.5605C3.84374 12.6226 3.80169 12.625 2.8298 12.625C1.83607 12.625 1.8183 12.6239 1.66517 12.5547C1.57963 12.5161 1.47171 12.4388 1.42536 12.383C1.26175 12.1862 1.25397 12.1281 1.25244 11.0912L1.25287 8.875"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M10.624 11.1014V11.6028C10.624 12.1492 10.6479 12.2516 10.8129 12.4112C10.8611 12.4578 10.9592 12.525 11.0309 12.5605C11.1563 12.6226 11.1983 12.625 12.1702 12.625C13.1639 12.625 13.1817 12.6239 13.3348 12.5547C13.4204 12.5161 13.5283 12.4388 13.5746 12.383C13.7382 12.1862 13.746 12.1281 13.7476 11.0912L13.7471 8.875"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M12.5 5.125L13.4375 4.8125"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 5.125L1.5625 4.8125"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CarIcon;
